import { createLogic } from 'redux-logic';
import { toastr } from 'react-redux-toastr';

import { SEND_PROPOSALS_URL, SEND_PROPOSALS_URL_RUBI_YIELD } from 'utils/api';
import axios from 'utils/axios';

import { SEND_PROPOSAL } from '../constants/proposal';
import { SendProposalSuccess, SendProposalError } from '../actions/proposal';

export const buildPayloadRequest = ({ operationId, clients }) => ({
  operacaoId: operationId,
  propostas: clients.map(client => ({
    cliente: client.clienteId,
    quantidade: client.quantity,
    operacaoId: operationId,
  })),
});

export const buildRubiYieldPayloarRequest = ({ clients }) => ({
  listaDetalhesOperacao: clients.map(client => ({
    codigoCliente: client.clienteId,
    quantidade: client.quantity,
  })),
});

export default createLogic({
  type: SEND_PROPOSAL,
  latest: true,

  process({ requestUtil, action }, dispatch, done) {
    const { payload } = action;
    const { isNewOperation } = payload;
    const ROUTE = isNewOperation
      ? SEND_PROPOSALS_URL_RUBI_YIELD.replace('{tradeIdeaId}', action.payload.operationId)
      : SEND_PROPOSALS_URL;

    axios.post(
      ROUTE,
      !isNewOperation ? buildPayloadRequest(action.payload) : buildRubiYieldPayloarRequest(action.payload),
    )
      .then((response) => {
        const { propostas, mensagens } = response.data;
        if (isNewOperation) {
          if (response.status !== 200) {
            /* const msgError = response.data.erros.length > 0
              ? response.data.erros.map(msg => (msg.descricao)).join(' ')
              : 'Tente novamente mais tarde'; */

            toastr.error('Ocorreu um erro ao enviar a proposta. Tente novamente mais tarde');
            dispatch(SendProposalError());
          } else {
            const res = {
              ...response.data,
              mensagens: response.data.erros || [],
            };
            dispatch(SendProposalSuccess(res));
          }
        } else if (response.data.error || propostas.length === 0) {
          const msgError = mensagens.length > 0
            ? mensagens.map(msg => (msg.descricao)).join(' ')
            : 'Tente novamente mais tarde';

          toastr.error('Erro ao enviar proposta', msgError);
          dispatch(SendProposalError());
        } else {
          dispatch(SendProposalSuccess(response.data));
        }
      }).catch((e) => {
        console.log('error', e.response.data);
        toastr.error('Ocorreu um erro ao enviar a proposta. Tente novamente mais tarde');
        dispatch(SendProposalError(e.response.data.erros));
      })
      .then(done);
  },
});
